export interface HeaderLink {
  title: string;
  href: string;
}

export const headerLinks: Array<HeaderLink> = [
  {
    title: "About",
    href: "#about",
  },
  {
    title: "Projects",
    href: "#projects",
  },
  {
    title: "Contact",
    href: "#contact",
  },
];
